export enum MissionHistoryActionTypes {
  CLAIM_MISSION_REWARDS = '@mission-history/CLAIM_MISSION_REWARDS',
  GET_ACTIVE_BUNDLES = '@mission-history/GET_ACTIVE_BUNDLES',
  GET_ACTIVE_MISSIONS = '@mission-history/GET_ACTIVE_MISSIONS',
  GET_EXPIRED_MISSIONS = '@mission-history/GET_EXPIRED_MISSIONS',
  GET_EXPIRED_BUNDLES = '@mission-history/GET_EXPIRED_BUNDLES',
}
